<div class="aspect-ratio-parent square">
    <div class="aspect-ratio">
        <div class="content">
            <ng-content></ng-content>
        </div>
    </div>
</div>